import { ScreenWidth, ScreenWidthValues } from 'web-common/src/shared/styles';

export const breakpointWidth = ScreenWidthValues[ScreenWidth.SMALL];
